import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { InputBaseModel } from '../../models';
import { InputRenderer } from '../../components';
import { NodeProps } from '../../componentTypes';
import { LayoutRenderer } from '../../layout_renderers';
import { InputIds, NodeIds } from '../../misc';
import { Utils } from '../../../custom_shared/misc';
import { useNodeForm } from '../../hooks';
import { GetComponentRowsFunction, ComponentRow } from '../../componentTypes';
import { InputComponentRegistry } from '../../node_inputs';

const InputComponents = InputComponentRegistry[NodeIds.Adjustments];

const AdjustmentsNodeRenderer: React.FC<NodeProps> = ({ node }: NodeProps) => {
    const { form, formKey, onValuesChange } = useNodeForm(node);

    const getComponentRows: GetComponentRowsFunction = React.useCallback((inputs: InputBaseModel[]) => {
        const rows: ComponentRow[] = [];

        const adjustmentsCountInput = inputs.find(i => i.id === InputIds.Adjustments.AdjustmentsCount);

        if (adjustmentsCountInput) {
            rows.push([
                {
                    component: (
                        <InputRenderer
                            key={adjustmentsCountInput.id}
                            input={adjustmentsCountInput}
                            component={InputComponents[InputIds.Adjustments.AdjustmentsCount]}
                        />
                    )
                }
            ]);
        }

        const restInputs = inputs.filter(i => i.id !== InputIds.Adjustments.AdjustmentsCount);

        rows.push(
            ...Utils.groupArray(restInputs, 2).map(inputGroup =>
                inputGroup.map(input => ({
                    component: (
                        <InputRenderer
                            key={input.id}
                            input={input}
                            component={InputComponents[input.id as keyof typeof InputComponents]}
                        />
                    )
                }))
            )
        );

        return rows;
    }, []);

    return (
        <LayoutRenderer
            node={node}
            form={form}
            formKey={formKey}
            onValuesChange={onValuesChange}
            getComponentRows={getComponentRows}
        />
    );
};

export default observer(AdjustmentsNodeRenderer);
